<br>
<br>
<br>
<br>
    <!-- Step 2 starts here -->
    <div class="stepper_content_2">
        <div class="carrier_details">
          <div class="stepper_head">
            <span
              class="opensans-semi-bold-sapphire-30px design"
              >Invoice - Annual Compliance
            </span>
          </div>
          <div class="detail_row">
            <div class="column">Account ID:</div>
            <div class="column">
              {{ currentPermitDetails.carrier_account_id }}
            </div>
          </div>
          <div class="detail_row">
            <div class="column">Application Number:</div>
            <div class="column">  {{ currentPermitDetails.application_id }}</div>
          </div>
          <div class="detail_row">
            <div class="column">Application Date:</div>
            <div class="column">
              {{
                currentPermitDetails?.date_created
                  | date:'dd/MM/y'
              }}
            </div>
          </div>
          <div class="detail_row">
            <div class="column">Applicant:</div>
            <div class="column">
              {{ currentPermitDetails?.trading_name | checknull }}
            </div>
          </div>
          <div class="detail_row">
            <div class="column">Email Address:</div>
            <div class="column">
              {{ currentPermitDetails?.email | checknull }}
            </div>
          </div>
          <div class="detail_row">
            <div class="column">Physical Address:</div>
            <div class="column">
              {{ currentPermitDetails?.physical_address_1 | checknull }}
            </div>
          </div>
          <div class="detail_row">
            <div class="column">Country:</div>
            <div class="column">{{ countryName }}</div>
          </div>
          <div class="detail_row">
            <div class="column">Post Code:</div>
            <div class="column">
              {{ currentPermitDetails?.postalCode }}
            </div>
          </div>
        </div>
        <br />
        <br />
        <div class="row links_row">
          <div class="col-8 btn-wrap">
            <button
              [disabled]="accountBalance < feeToBePaid"
              [ngClass]="accountBalance < feeToBePaid ? 'disabled' : ''"
              (click)="submitApplication('1')"
              class="btn_wrap"
            >
              <img src="../../assets/img/dollar_icon.svg" alt="" />
              Submit and Pay Using Balance
            </button>
            <button href="#" class="btn_wrap" (click)="submitApplication('2')">
              <img src="../../assets/img/dollar_icon.svg" alt="" />
              Submit and Pay Using Gateway
            </button>
          </div>
          <div class="col-4">
            <div class="account_balance">
              <span>Account Balance</span>
              <span>{{
                accountBalance ? (accountBalance | currencyFormat) : "R 0.00"
              }}</span>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table custom_table" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th>Vehicle Registration Number</th>
                <th class="permit_type">Permit type</th>
                <th>Permit Number</th>
                <th class="text-right">Permit Start date</th>
                <th class="text-right">Permit end date</th>
                <th class="text-right">Compliance Start date</th>
                <th class="text-right">Compliance End date</th>
                <th>Status</th>
                <th class="text-right">Duplicate Fee</th>
                <th class="text-right">Application Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vehicle of complianceVehicleDetails">
                <td>{{ vehicle.registration_number | checknull }}</td>
                <td>{{ vehicle.permit_type | checknull }}</td>
                <td>{{ vehicle.permit_num | checknull }}</td>
                <td class="text-right">
                  {{ vehicle.permit_start | date : "dd/MM/yyyy" }}
                </td>
                <td class="text-right">
                  {{ vehicle.permit_end | date : "dd/MM/yyyy" }}
                </td>
                <td class="text-right">
                  {{ vehicle.date_valid_from | date : "dd/MM/yyyy" }}
                </td>
                <td class="text-right">
                  {{ vehicle.date_valid_to | date : "dd/MM/yyyy" }}
                </td>
                <td>
                  <div *ngIf="vehicle.compliance_status !== 'Saved'; else due">
                    {{ vehicle.compliance_status | checknull }}
                  </div>
                  <ng-template #due>
                    <span> Due </span>
                  </ng-template>
                </td>
                <!-- <td>{{ vehicle.compliance_status }}</td> -->
                <td class="text-right">
            R {{
              vehicle?.duplicate_fee == null
                ? "0"
                : vehicle?.duplicate_fee
            }}
          </td>
                <td class="text-right">  R {{
                  vehicle?.line_total == null
                    ? "0"
                    : vehicle?.line_total
                }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right price_wrapper" >
          <div class="price" >
            Total:
            <span class="blue"> <strong>R</strong> {{ total }} </span>
          </div>
          <div class="price">
            Payable Amount:
            <span class="blue"> <strong>R</strong> {{ total }} </span>
          </div>
          <div class="price">
            Due for these annual Compliance:
            <span class="red"> <strong>R</strong> {{ total  }} </span>
          </div>
        </div>
        <br />
        <br />
        <div class="col-12 action_buttons_wrapper">

          <button
          title="Back"
          type="submit"
          id="btnNext"
          (click)="prevStep()"
          class="btn hd-btn"
        >
        Back
        </button>
        
          <button
            title="Close"
            type="submit"
            id="btnCancel"
            (click)="cancel()"
            class="btn hd-btn-close"
          >
            Close
          </button>
        </div>
      </div>
      <br />
      <!-- Step 2 ends here -->

      <form
  [formGroup]="checkoutForm"
  name="checkoutForm"
  id="checkoutForm"
  (ngSubmit)="onSubmit(checkoutForm, $event)"
  method="post"
  [action]="payGateUrl"
>
  <input
    type="hidden"
    formControlName="PAY_REQUEST_ID"
    name="PAY_REQUEST_ID"
    [(ngModel)]="payReqId"
  />
  <input
    type="hidden"
    formControlName="CHECKSUM"
    name="CHECKSUM"
    [(ngModel)]="checkSum"
  />
  <button
    style="display: none"
    name="checkoutFormBtn"
    id="checkoutFormBtn"
    class="button"
    type="submit"
  >
    Purchase
  </button>
</form>